import { c as _c } from "react/compiler-runtime";
// Counted filter chips — the console's one way to categorise a table.
//
// The applications board grew this pattern first (status chips that are also
// filters) and the founder read it immediately: the count tells her the shape
// of the queue, the click narrows to it. Orders, carts, users and notifications
// had a bare search box or nothing at all, so each was a wall of rows with no
// way in. Same control everywhere rather than four different inventions.
//
// A chip whose count is zero still renders: "0 problem orders" is information,
// and a row of chips that reshuffles as data changes is harder to aim at.
import { Badge } from "@osmix/ui/badge";
import { cn } from "@/lib/utils";
export type FilterChip<T extends string> = {
  value: T;
  label: string;
  count: number;
  /** Chips that report trouble carry the colour of the trouble. */
  tone?: "default" | "warning" | "danger";
};
const TONE_ACTIVE: Record<string, string> = {
  default: "border-primary bg-primary/10",
  warning: "border-amber-500 bg-amber-500/15 text-amber-700 dark:text-amber-500",
  danger: "border-destructive bg-destructive/15 text-destructive"
};
const TONE_IDLE: Record<string, string> = {
  default: "hover:bg-muted/60",
  warning: "text-amber-700 hover:bg-amber-500/10 dark:text-amber-500",
  danger: "text-destructive hover:bg-destructive/10"
};
export function FilterChips(t0) {
  const $ = _c(26);
  const {
    value,
    chips,
    onChange,
    allLabel,
    allCount,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-wrap items-center gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onChange) {
    t2 = () => onChange("");
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = value === "" ? "border-primary bg-primary/10" : "hover:bg-muted/60";
  let t4;
  if ($[4] !== t3) {
    t4 = cn("flex items-center gap-2 rounded-full border px-3 py-1 text-sm transition-colors", t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== allLabel) {
    t5 = <span>{allLabel}</span>;
    $[6] = allLabel;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== allCount) {
    t6 = <Badge variant="secondary" className="tabular-nums">{allCount}</Badge>;
    $[8] = allCount;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <button type="button" onClick={t2} className={t4}>{t5}{t6}</button>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== chips || $[16] !== onChange || $[17] !== value) {
    let t9;
    if ($[19] !== onChange || $[20] !== value) {
      t9 = chip => {
        const active = value === chip.value;
        const tone = chip.tone ?? "default";
        return <button key={chip.value} type="button" onClick={() => onChange(active ? "" : chip.value)} className={cn("flex items-center gap-2 rounded-full border px-3 py-1 text-sm transition-colors", active ? TONE_ACTIVE[tone] : TONE_IDLE[tone])}><span>{chip.label}</span><Badge variant="secondary" className="tabular-nums">{chip.count}</Badge></button>;
      };
      $[19] = onChange;
      $[20] = value;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t8 = chips.map(t9);
    $[15] = chips;
    $[16] = onChange;
    $[17] = value;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[22] !== t1 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className={t1}>{t7}{t8}</div>;
    $[22] = t1;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}